import * as React from 'react';

/**
 * Legacy /join route — redirects to /signup preserving the invite param.
 */
export default function Join() {
  React.useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    const invite = search.get('invite');
    const target = invite ? `/signup?invite=${encodeURIComponent(invite)}` : '/signup';
    window.location.replace(target);
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6 text-foreground">
      <p>Redirecting…</p>
    </div>
  );
}
